import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { InformacionClienteModal } from "app/features/componentes/guia/informacionclientemodal"
import { Session } from "app/resources/index";
const EditModal = InformacionClienteModal;

type Entity = models.GuiaDTO;
export interface Props {
    value: Entity[];
    hideBusqueda?: boolean;
    cookieKey?: string;
}

function paqueteToString(x: models.Paquete) {
    return `${x.Cantidad} x (${x.Peso} kg ${x.Alto}x${x.Largo}x${x.Ancho} cm)`;
}
const arrayCellPaquetes = kea.arrayCell<models.Paquete>({
    itemToString: paqueteToString,
    columns: [
        {
            cell: x => "" + x.Cantidad,
            title: "Cantidad"
        }, {
            cell: x => x.Peso + " kg",
            title: "Peso"
        }, {
            cell: x => x.Alto + " cm",
            title: "Alto"
        }, {
            cell: x => x.Largo + " cm",
            title: "Largo"
        }, {
            cell: x => x.Ancho + " cm",
            title: "Ancho"
        }, {
            cell: (x: models.PaqueteDTO) => x.NombreDescripcionPaquete,
            title: "Descripción"
        }, {
            cell: (x: models.PaqueteDTO) => x.NombreContenidoPaquete,
            title: "Contenido"
        }, {
            cell: x => kea.formatCurrency(x.ValorDeclarado),
            title: "Valor declarado"
        },
    ]
});

const arrayCellStatus = kea.arrayCell<models.StatusGuiaViewDTO>({
    itemToString: x => models.StatusGuia[x.Status],
    columns: [
        {
            cell: x => kea.formatDate(x.Fecha),
            title: "Fecha"
        }, {
            cell: x => models.StatusGuia[x.Status],
            title: "Status"
        }, {
            cell: x => x.NombreSucursal,
            title: "Sucursal"
        }, {
            cell: x => x.NombreContactoClienteRecibio,
            title: "Contacto recibió"
        }
    ]
})

function obtenerServAdicionalesGuia(x: models.ServiciosAdicionalesGuiaDTO | null): string[] {
    if(!x) return [];
    
    const ret = [
        x.EntregaDomicilio ? "Entrega a domicilio" : undefined,
        x.RecoleccionDomicilio ? "Recolección a domicilio" : undefined,
        x.TipoAcuse == models.TipoAcuse.Interno ? "Acuse interno" : undefined,
        x.TipoAcuse == models.TipoAcuse.Externo ? `Acuse externo (${x.NombreRequerimientoAcuse})` : undefined,
    ];
    return ret.filter(x => x != null).map(x => x!);
}


export interface BotonesListaDeps {
    onVer: (x: Entity) => void;
    onVerFirma: (x: Entity) => void;
    onImprimir: (x: Entity) => void;
    onCancelar: (x: Entity) => void;
    onReporteAcuse: (x: Entity) => void;
}

export const columnasFijas: kea.Grid2Column<Entity>[] = [
    {
        title: "No. guia", cell: x => ({
            data: x.Folio, view: () =>
                <span style={{ fontFamily: "monospace" }} >
                    {x.Folio}
                    {
                        x.EsDeAcuse &&
                        <span className="label label-danger" >ACU</span>
                    }
                    { x.EsZonaExtendida && <span className="label label-warning" >ZE</span>}
                </span>
        })
    },
    { title: "Factura", cell: x => ({ data: x.FolioFactura }) },
    { title: "Cancelada", cell: x => ({ data: x.EsCancelada }) },
    { title: "Status", cell: x => ({ data: models.StatusGuia[x.Status] }) },
    { title: "Sucursal actual", cell: x => ({ data: x.Posicion }) },
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Cliente origen", cell: x => ({ data: x.NombreClienteOrigen }) },
    { title: "Origen", cell: x => ({ data: x.DireccionOrigenDTO && x.DireccionOrigenDTO.Descripcion }) },
    { title: "Suc origen", cell: x => ({ data: x.NombreSucursalOrigen }) },
    { title: "Cliente destino", cell: x => ({ data: x.NombreClienteDestino }) },
    { title: "Destino", cell: x => ({ data: x.DireccionDestinoDTO && x.DireccionDestinoDTO.Descripcion }) },
    { title: "Suc destino", cell: x => ({ data: x.NombreSucursalDestino }) },
    { title: "Paquetes", cell: x => ({ data: (x.DescripcionPaquetesVolumen || "").split(", ") }) },
    { title: "Paquetes (detalle)", cell: x => ({ data: (x.DescripcionPaquetesTexto || "").split(", ") }) },
    { title: "Cantidad Paquetes", cell: x => ({ data: x.CantidadPaquetes }) },
    { title: "Sobres", cell: x => ({ data: x.CantidadSobres }) },
    { title: "Distancia flete (km)", cell: x => ({ data: x.DistanciaFlete }) },
    { title: "Serv. adic.", cell: x => ({ data: obtenerServAdicionalesGuia(x.ServiciosAdicionales) }) },
    { title: "Ruta de EAD", cell: x => ({ data: x.NombreRutaEntregaDomicilio }) },
    { title: "Flete por cobrar", cell: x => ({ data: x.FletePorCobrar }) },
    { title: "Pagada", cell: x => ({ data: x.Pagada }) },
    { title: "A crédito", cell: x => ({ data: x.EsDeCredito }) },
    { title: "Importe total", cell: x => ({ data: x.Importes ? x.Importes.Total : "", view: x.Importes ? kea.formatCurrency : undefined }) },
    { title: "Otros importes", cell: x => ({ data: x.Importes }) },
    { title: "Requiere contacto autorizado", cell: x => ({ data: x.RequiereContactoAutorizado }) },
    { title: "Contacto recibio", cell: x => ({ data: x.NombreContactoRecibio }) },
    { title: "Es de acuse", cell: x => ({ data: x.EsDeAcuse }) },
    { title: "Folio acuse original", cell: x => ({ data: x.FolioGuiaAcuse }) },
    { title: "Todos los status", cell: x => ({ data: x.StatusHistoricos, view: arrayCellStatus }) },
    { title: "Fecha de entrega", cell: x => ({ data: kea.toDate(x.FechaEntrega) }) },
    { title: "Fecha de facturación", cell: x => ({ data: kea.toDate(x.FechaDeFacturacion) }) },
    { title: "Fecha de poliza contable", cell: x => ({ data: kea.toDate(x.FechaDePoliza) }) },
    { title: "Fecha de pago", cell: x => ({ data: kea.toDate(x.FechaDePago) }) },
    { title: "Usuario documentó", cell: x => ({ data: x.NombrePersonaDocumento }) },
    { title: "Usuario entregó", cell: x => ({ data: x.NombrePersonaEntrego }) },
    { title: "Tipo de seguro", cell: x => ({ data: nullsafe(x.TipoSeguro, x => models.TipoSeguroGuia[x]) }) },
    { title: "Valor declarado", cell: x => ({ data: x.ValorDeclarado }) },
    { title: "Motivo rechazo", cell: x => ({ data: x.MotivoRechazo }) },
    { title: "Fecha límite de facturación", cell: x => ({ data: kea.toDate(x.FechaLimiteFacturacion) }) },
    { title: "Tarifa", cell: x => ({ data: x.NombreTarifa }) },
    { title: "Observaciones", cell: x => ({ data: (x.ObservacionesGuia || "").split("|") }) },
    { title: "RFC cliente paga", cell: x => ({ data: x.RfcClientePaga }) },
    { title: "Zona ext.", cell: x => ({ data: x.NombreZonaExtendida }) },
    { title: "Motivo de rechazo de público general", cell: x => ({ data: x.MotivoRechazoPublicoGeneral }) },
]

/**Obtiene las columnas del grid */
function columnas(deps: BotonesListaDeps, session: models.Session): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones<Entity>([
        {
            onClick: x => deps.onVer(x),
            tooltip: "Ver",
            iconClass: fa("eye"),
        }, {
            onClick: x => deps.onImprimir(x),
            tooltip: "Imprimir",
            iconClass: fa("print")
        }, {
            onClick: x => deps.onReporteAcuse(x),
            disabled: x => !x.PuedeImprimirAcuseInterno,
            tooltip: "Imprimir acuse interno",
            iconClass: fa("file-o")
        }, {
            onClick: x => deps.onCancelar(x),
            disabled: x => !session.Permisos.Guia.VerBotonCancelarGuia  || 
            (
                x.Status != models.StatusGuia.EnSucursalDestino &&
                x.Status != models.StatusGuia.RecoleccionPendiente &&
                x.Status != models.StatusGuia.EnSucursalOrigen
            )
        ,
            tooltip: "Cancelar guia",
            iconClass: fa("times-circle-o")
        }, {
            onClick: x => deps.onVerFirma(x),
            disabled: x => 
            !session.Permisos.Rastreo.VerBotonInformacionCliente 
            || (
                x.Status != models.StatusGuia.EntregadaOcurre 
                && x.Status != models.StatusGuia.EntregadaDomicilio
                && x.Status != models.StatusGuia.EntregadaZonaExtendida
            ),
            tooltip: "Ver firma del cliente",
            iconClass: fa("pencil-square-o")
        }
    ]);

    const columnasFijas2: kea.Grid2Column<Entity>[] = [
        {
            title: "No. guia", cell: x => ({
                data: x.Folio, view: () =>
                    <span style={{ fontFamily: "monospace" }} >
                        {x.Folio}
                        {
                            x.EsDeAcuse &&
                            <span className="label label-danger" >ACU</span>
                        }
                        {
                            x.EsGuiaPP && " " &&
                            <span className="label label-primary" >PP</span>
                        }
                        { x.EsZonaExtendida && <span className="label label-warning" >ZE</span>}
                    </span>
            })
        },
        { title: "Factura", cell: x => ({ data: x.FolioFactura }) },
        { title: "Cancelada", cell: x => ({ data: x.EsCancelada }) },
        { title: "Status", cell: x => ({ data: models.StatusGuia[x.Status] }) },
        { title: "Sucursal actual", cell: x => ({ data: x.Posicion }) },
        { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },

        {
            title: "Nombre cliente origen", cell: x => ({
                data: x.NombreClienteOrigen, view: () =>
                session.Permisos.Catalogos.Cliente.EditarDesdeListadoGuias ? 
                    <a href= { "/#/catalogos/Cliente/"+x.IdClienteOrigen } >
                        <span title={x.NombreClienteOrigen}>
                            {x.NombreClienteOrigen}
                        </span>
                    </a>
                :
                    <span title={x.NombreClienteOrigen}>
                        {x.NombreClienteOrigen}
                    </span>
            })
        }
        ,
        { title: "Dirección del cliente origen", cell: x => ({ 
            data: x.DireccionOrigenDTO, view: () =>
                <span title={x.DireccionOrigenDTO.Descripcion}>
                    {x.DireccionOrigenDTO.Descripcion}
                </span>
        }) },
        { title: "Suc origen", cell: x => ({ data: x.NombreSucursalOrigen }) },
        
        {
            title: "Nombre cliente destino", cell: x => ({
                data: x.NombreClienteDestino, view: () =>
                session.Permisos.Catalogos.Cliente.EditarDesdeListadoGuias ? 
                    <a href= { "/#/catalogos/Cliente/"+x.IdClienteDestino } >
                        <span title={x.NombreClienteDestino}>
                            {x.NombreClienteDestino}
                        </span>
                    </a>
                :
                    <span title={x.NombreClienteDestino}>
                        {x.NombreClienteDestino}
                    </span>
            })
        }
        ,
        { title: "Dirección del cliente Destino", cell: x => ({ 
            data: x.DireccionDestinoDTO.Descripcion, view: () =>
                <span title={x.DireccionDestinoDTO.Descripcion}>
                    {x.DireccionDestinoDTO.Descripcion}
                </span>
        }) },
        { title: "Suc destino", cell: x => ({ data: x.NombreSucursalDestino }) },
        { title: "Paquetes", cell: x => ({ data: (x.DescripcionPaquetesVolumen || "").split(", ") }) },
        { title: "Paquetes (detalle)", cell: x => ({ data: (x.DescripcionPaquetesTexto || "").split(", ") }) },
        { title: "Cantidad Paquetes", cell: x => ({ data: x.CantidadPaquetes }) },
        { title: "Sobres", cell: x => ({ data: x.CantidadSobres }) },
        { title: "Distancia flete (km)", cell: x => ({ data: x.DistanciaFlete }) },
        { title: "Serv. adic.", cell: x => ({ data: obtenerServAdicionalesGuia(x.ServiciosAdicionales) }) },
        { title: "Ruta de EAD", cell: x => ({ data: x.NombreRutaEntregaDomicilio }) },
        { title: "Flete por cobrar", cell: x => ({ data: x.FletePorCobrar }) },
        { title: "Pagada", cell: x => ({ data: x.Pagada }) },
        { title: "A crédito", cell: x => ({ data: x.EsDeCredito }) },

        { title: "Importe total", cell: x => ({ data: ( session != undefined && session != null ) && session.IdUsuarioZE==null && x.Importes ? x.Importes.Total : "", view: x.Importes ? kea.formatCurrency : undefined }) },
        { title: "Importe PP", cell: x => ({ data: x.ImporteGuiaPP, view: kea.formatCurrency }) },
        { title: "Importe total + PP", cell: x => ({ data: x.ImporteTotalConGuiaPP, view: kea.formatCurrency }) },
        
        { title: "Otros importes", cell: x => ({ data: session != undefined && session != null ? x.Importes : "" }) },
        { title: "Requiere contacto autorizado", cell: x => ({ data: x.RequiereContactoAutorizado }) },
        { title: "Contacto recibio", cell: x => ({ data: x.NombreContactoRecibio }) },
        { title: "Es de acuse", cell: x => ({ data: x.EsDeAcuse }) },
        { title: "Folio acuse original", cell: x => ({ data: x.FolioGuiaAcuse }) },
        { title: "Todos los status", cell: x => ({ data: x.StatusHistoricos, view: arrayCellStatus }) },
        { title: "Fecha de entrega", cell: x => ({ data: kea.toDate(x.FechaEntrega) }) },
        { title: "Fecha de facturación", cell: x => ({ data: kea.toDate(x.FechaDeFacturacion) }) },
        { title: "Fecha de poliza contable", cell: x => ({ data: kea.toDate(x.FechaDePoliza) }) },
        { title: "Fecha de pago", cell: x => ({ data: kea.toDate(x.FechaDePago) }) },
        { title: "Usuario documentó", cell: x => ({ data: x.NombrePersonaDocumento }) },
        { title: "Usuario entregó", cell: x => ({ data: x.NombrePersonaEntrego }) },
        { title: "Tipo de seguro", cell: x => ({ data: nullsafe(x.TipoSeguro, x => models.TipoSeguroGuia[x]) }) },
        { title: "Valor declarado", cell: x => ({ data: x.ValorDeclarado }) },
        { title: "Motivo rechazo", cell: x => ({ data: x.MotivoRechazo }) },
        { title: "Fecha límite de facturación", cell: x => ({ data: kea.toDate(x.FechaLimiteFacturacion) }) },
        { title: "Tarifa", cell: x => ({ data: x.NombreTarifa }) },
        { title: "Observaciones", cell: x => ({ data: (x.ObservacionesGuia || "").split("|") }) },
        { title: "RFC cliente paga", cell: x => ({ data: x.RfcClientePaga }) },
        { title: "Zona ext.", cell: x => ({ data: x.NombreZonaExtendida }) },
        { title: "Motivo de rechazo de público general", cell: x => ({ data: x.MotivoRechazoPublicoGeneral }) },
    ]

    return [
        botones,
        ...columnasFijas2
    ];
}

/**
* Listado de 
*/
class GuiasListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    permisos = (x: Props) => resources.User.PermisoRx;
    session = (x: Props) => resources.User.SessionRx;


    columnas = createSelectorRx(this.session, session => columnas(this, session));

    onVer = async (x: Entity) => {
        await history.go("/operativa/guias/" + x.Folio);
    }

    onVerFirma = async (x: Entity) => {
        var guia = x
        var informacion = await resources.Rastreo.ObtenerInformacionCliente(guia.Folio);
        const result = await this.modals.showModal(EditModal, undefined, informacion);
    }

    onImprimir = async (x: Entity) => {
        const data = await resources.Guia.ReporteGuia(x.Folio);
        kea.printPdf(data);
    }

    onCancelar = async (x: Entity) => {
        if (await kea.yesno("¿Seguro que desea cancelar esta guia?")) {
            await resources.Guia.CancelarGuia(x.Folio);
            await kea.message("La guía fue cancelada");
        }
    }

    onReporteAcuse = async (x: Entity) => {
        const data = await resources.Guia.ReporteAcuse(x.Folio);
        await kea.download(kea.base64ToBlob((data)), "Acuse de recibo de " + x.Folio + ".pdf");
    }

    render() {
        const permisos = this.permisos(this.props);
        const cols = this.columnas(this.props);

        return (
            <div>
                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda={this.props.hideBusqueda} cookieKey={this.props.cookieKey} />
                {this.modals.component}
            </div>
        );
    }
}
/**Listado de las guias en memoria */
export const GuiaListMem = kea.mapProps(componentToRx(GuiasListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/list/listmem.tsx